import Home from './home/Home.vue'
import UserManagement from './user-management/user-management-routes'
import Redirect from './common/Redirect.vue'
import UserRoles from './user-roles/user-roles-routes'
import Login from './login/login-routes'
import Invite from './invite/invite-routes'
import Debug from './debug/debug-routes'
import Locations from './locations/location-routes'
import Companies from './companies/companies-routes'
import Groups from './groups/group-routes'
import Menu from './menu/menu-routes'
import LocationSettings from './location-settings/location-settings-routes'
import Employment from './employment/employment-routes'
import Customer from './customer/customer-routes'
import TicketFinder from './ticket-finder/ticket-finder-routes'
import Kiosk from './kiosk/kiosk-routes'
import Router from 'vue-router'

export const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/auth',
      name: 'auth',
      props: route => ({
        redirectUri: route.query.redirect_uri,
        source: route.query.source,
        state: route.query.state
      }),
      meta: { hideNavigation: true },
      component: () => import('./authorize/Authorize.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/news/:companyId',
      name: 'news',
      component: () => import('./home/news-admin/NewsAdmin')
    },
    {
      path: '/storeSummary',
      name: 'storeSummary',
      component: () => import('./dashboard/StoreSummary')
    },
    {
      path: '/serverPerformance',
      name: 'serverPerformance',
      component: () => import('./dashboard/ServerPerformance')
    },
    {
      path: '/productMix',
      name: 'productMix',
      component: () => import('./dashboard/ProductMix')
    },
    {
      path: '/deliveries',
      name: 'deliveries',
      component: () => import('./dashboard/Deliveries')
    },
    {
      path: '/employeePayroll',
      name: 'employeePayroll',
      component: () => import('./dashboard/EmployeePayroll')
    },
    {
      path: '/allReports',
      name: 'allReports',
      component: () => import('./dashboard/AllReports')
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: Redirect
    },
    ...Login,
    ...Invite,
    ...UserManagement,
    ...UserRoles,
    ...Debug,
    ...Locations,
    ...Companies,
    ...Groups,
    ...Menu,
    ...LocationSettings,
    ...Employment,
    ...Customer,
    ...TicketFinder,
    ...Kiosk
  ]
})
